// extracted by mini-css-extract-plugin
module.exports = {"customInput":"index_customInput__3PiLr","wrapperRemove":"index_wrapperRemove__2xZba","removeIcon":"index_removeIcon__2tgWN","actionBtn":"index_actionBtn__3zka4"};